import { useState, useEffect } from 'react';
import { useTranslation } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Download, X } from 'lucide-react';

const InstallPWA = () => {
  const { t } = useTranslation();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      const dismissed = sessionStorage.getItem('pwa_dismissed');
      if (!dismissed) setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // Register service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    sessionStorage.setItem('pwa_dismissed', '1');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-[100] animate-fade-in-up" data-testid="pwa-install-banner">
      <div className="bg-[var(--card-bg)] border border-white/10 rounded-2xl p-4 card-shadow flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl gradient-warm flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-[var(--text-primary)] text-sm">{t('pwa.install')}</p>
          <p className="text-xs text-[var(--text-secondary)] truncate">{t('pwa.installDesc')}</p>
        </div>
        <Button size="sm" onClick={handleInstall} className="rounded-full gradient-warm text-white text-xs font-bold px-3" data-testid="pwa-install-btn">
          {t('pwa.install')}
        </Button>
        <button onClick={handleDismiss} className="text-[var(--text-muted)] hover:text-[var(--text-primary)]">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallPWA;
